<template>
    <div class="agencyCenterBox">
        <ul class="isOverNav">
            <li v-for="(value,index) in isOverNav" :key="index" :class="{active:isOverNavActive === index}" @click="handleNavActive(index)">{{value}}</li>
        </ul>
        <agencyList :pAgencyOrOver="agencyOrOver" ></agencyList>
    </div>
</template>

<script>
    // import api from '../../../../service/modules/integrity'
    import agencyList from '../../components/AgencyCenterList.vue'
    export default {
        components: {
            agencyList
        },
        data () {
            return {
                isOverNav: [
                    '待处理',
                    '已完成'
                ],
                isOverNavActive: 0,
                agencyOrOver: true,
                pageIndex: 1,
                pageSize: 8
            }
        },
        created () {
        },
        methods: {
            handleNavActive (index) {
                this.isOverNavActive = index
                if (this.isOverNavActive === 0) {
                    this.agencyOrOver = true
                } else {
                    this.agencyOrOver = false
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .agencyCenterBox{
        width: 100%;
        min-height: 100%;
        padding: 16px 12px;
        background-color: #FBFBFB;

        .isOverNav{
            margin-bottom: 12px;

            >li{
                height: 30px;
                margin-right: 24px;
                font-size: 14px;
                color:rgba(51,51,51,1);
                text-align: center;
                line-height: 35px;
                border-top: 2px solid transparent;
                border-bottom: 2px solid transparent;
                float: left;
            }

            >li.active{
                color: #36B374;
                border-bottom-color: #36B374;
                font-weight: bolder;
            }
        }

        .isOverNav::after{
                content: '';
                display: block;
                clear: both;
        }

        .situationList{

            .situationListItem{
                width: 100%;
                height: 124px;
                margin-bottom: 12px;
                padding: 12px 16px 0 16px;
                background-color: #fff;
                border-radius:3px;

                .situationTopBox::after{
                    content: '';
                    display: block;
                    clear: both;
                }
                .situationTopBox{
                    height: 28px;
                    margin-bottom: 8px;

                    .situationTitle{
                        font-size: 14px;
                        font-weight: bold;
                        line-height: 28px;
                        float: left;
                    }

                    .situationBtn{
                        width: 64px;
                        height: 28px;
                        font-size: 12px;
                        text-align: center;
                        line-height: 28px;
                        color: #fff;
                        background-color: #36B374;
                        border-radius:2px;
                        float: right;
                    }
                }

                .situationDatailList{

                    >li::after{
                        content: '';
                        display: block;
                        clear: both;
                    }

                    >li{
                        height: 22px;

                        .detailTitle{
                            width: 110px;
                            font-size: 14px;
                            line-height: 22px;
                            color: #999;
                            float: left;
                        }

                        .situationData{
                            width: 209px;
                            font-size: 14px;
                            line-height: 22px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }

    }
</style>
